<div class="section-header">
	<div>
		<H2>Insurance</H2>
		Patient insurance details
	</div>

	<button mat-stroked-button (click)="savePatient()" >Save</button>
</div>

<div class="input-section">
	<div class="title">
		Insurance Status
	</div>
	<div class="fields">
		<div class="row">
			<mat-form-field>
				<mat-label class="label">Insurance Status</mat-label>
				<mat-select [(ngModel)]="this.patientInfo.data[SurveyQuestions.InsuranceStatus]">
					<mat-option value="SELF_PAY">Self Pay</mat-option>
					<mat-option value="INSURED">Insured</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	</div>
</div>

<app-insurance-input *ngIf="this.patientInfo.data[SurveyQuestions.InsuranceStatus] != 'SELF_PAY'" [insuranceType]="'Primary Insurance'" [patientInfo]="this.patientInfo" [insurance]="this.patientInfo.data[SurveyQuestions.Insurances][0]"></app-insurance-input>
<app-insurance-input *ngIf="this.patientInfo.data[SurveyQuestions.Insurances]?.length > 1 && this.patientInfo.data[SurveyQuestions.InsuranceStatus] != 'SELF_PAY'" [insuranceType]="'Secondary Insurance'" [canDelete]="true" [patientInfo]="this.patientInfo" [insurance]="this.patientInfo.data[SurveyQuestions.Insurances][1]"></app-insurance-input>
<app-insurance-input *ngIf="this.patientInfo.data[SurveyQuestions.Insurances]?.length > 2 && this.patientInfo.data[SurveyQuestions.InsuranceStatus] != 'SELF_PAY'" [insuranceType]="'Tertiary Insurance'" [canDelete]="true" [patientInfo]="this.patientInfo" [insurance]="this.patientInfo.data[SurveyQuestions.Insurances][2]"></app-insurance-input>

<div *ngIf="this.patientInfo.data[SurveyQuestions.Insurances]?.length  < 3 && this.patientInfo.data[SurveyQuestions.InsuranceStatus] != 'SELF_PAY'" class="input-section">
	<div class="title">
	</div>
	<div class="fields">
		<div class="row">
			<a class="add-insurance" (click)="addInsurance()">+ Add Insurance</a>
		</div>
	</div>
</div>

<div class="overview" *ngIf="this.patientInfo.data[SurveyQuestions.InsuranceStatus] != 'SELF_PAY'" >
	<div class="tasks">
		<div>
			<div class="line-item">
				<a class="complete-all" (click)="completeAll()">Complete All</a>
			</div>
			@for (task of controller.insurance.items; track task) {
				<div class="line-item">
					<div>{{ task.label }}</div>
					<mat-checkbox [(ngModel)]="taskValues[controller.insurance.id +'.'+task.id]"
					              (ngModelChange)="setValue(controller.insurance.id,task.id,$event)"></mat-checkbox>
				</div>
			}
		</div>
	</div>
</div>



